var map = {
	"./Commands/Commands.tsx": 52850,
	"./Commands/internal/Action.tsx": 96553,
	"./Commands/internal/Dialog.tsx": 79682,
	"./Footer/Footer.tsx": 30248,
	"./Footer/samples/basic.tsx": 67922,
	"./NavigationFooter/NavigationFooter.tsx": 77920,
	"./NavigationFooter/samples/basic.tsx": 16538,
	"./Page/Page.tsx": 15948,
	"./Page/components.tsx": 18527,
	"./Page/internal/Section.tsx": 66941,
	"./Page/internal/Sidebar.tsx": 27219,
	"./Page/internal/SidebarItem.tsx": 10534,
	"./Page/samples/basic.tsx": 96231,
	"./Page/samples/layout.tsx": 95495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 72507;
module.exports = webpackContext;